import { KPIOverviewSegmentCounts } from "../api/fetchKPIOverview/types";

export type KPIOverviewSegment = "all" | "needs_attention" | "data_gaps";

export interface KPIOverviewSegmentOption {
  value: KPIOverviewSegment;
  label: string;
  countKey: keyof KPIOverviewSegmentCounts;
}

export const DEFAULT_KPI_OVERVIEW_SEGMENT = "all" satisfies KPIOverviewSegment;

export const KPI_OVERVIEW_SEGMENTS: KPIOverviewSegmentOption[] = [
  { value: "all", label: "All members", countKey: "allMembers" },
  {
    value: "needs_attention",
    label: "Needs attention",
    countKey: "needsAttention",
  },
  { value: "data_gaps", label: "Data gaps", countKey: "dataGaps" },
];

export const EMPTY_KPI_OVERVIEW_SEGMENT_COUNTS: KPIOverviewSegmentCounts = {
  allMembers: 0,
  needsAttention: 0,
  dataGaps: 0,
};

export const parseKPIOverviewSegment = (
  value: string | null,
): KPIOverviewSegment =>
  KPI_OVERVIEW_SEGMENTS.find((segment) => segment.value === value)?.value ??
  DEFAULT_KPI_OVERVIEW_SEGMENT;
